export class SessionModel {
    public Id: string;
    public Timestamp: Date;
}
